import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

export const useDeviceDimensions = () => {
  const [deviceDimensions, setDeviceDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      if (
        window.innerWidth !== deviceDimensions.width ||
        window.innerHeight !== deviceDimensions.height
      ) {
        const timer: ReturnType<typeof setTimeout> = setTimeout(() => {
          setDeviceDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }, 500);
        return () => clearTimeout(timer);
      }
    }

    window.addEventListener("resize", handleResize);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("resize", handleResize);
    };
  });

  return {
    deviceDimensions: deviceDimensions,
    isMobile:
      (isMobile && deviceDimensions.width < 768) || (!isMobile && deviceDimensions.width < 768),
  };
};
